import './rating.scss';

export default () => {
	const ratingContainer = document.querySelector('.rating');
	const feedbackContainer = document.querySelector('.feedback');
	ratingContainer.addEventListener('click', () => {
		feedbackContainer.classList.toggle('feedback--active');
	});
};
